import { Component } from '@angular/core';

import { AbstractHypeService } from '../../../../Common/Layout/services/abstract-hype.service';
import { AutomationAgentsHypeService } from '../../services/automation-agents-hype.service';

/**
 * Shell for the Automation Agents area. Like Social, it renders full width with no left sidebar.
 */
@Component({
    selector: 'agpr-automation-agents',
    templateUrl: './automation-agents.component.html',
    styleUrls: ['./automation-agents.component.scss'],
    providers: [
        AutomationAgentsHypeService,
        {
            provide: AbstractHypeService,
            useExisting: AutomationAgentsHypeService
        }
    ],
    standalone: false
})
export class AutomationAgentsComponent {
    readonly id: string = 'automationAgents';
}
